import { useExamCenter } from '@exam-center/exam-center-details';
import {
  ExamLocationRequestWorkflowStepCode,
  useGetExamRoomRequestInfoByIdQuery,
} from '@exam-center/graphql';
import { Navigate } from '@exam-center/router';
import { Loading } from '@shared/components';
import { createContext, useMemo } from 'react';

import type { ExamRoomRequestInfoContextValue, ExamRoomRequestInfoProviderProps } from './types';

const ExamRoomRequestInfoContext = createContext<ExamRoomRequestInfoContextValue | undefined>(
  undefined,
);

export default function ExamRoomRequestInfoProvider(
  props: Readonly<ExamRoomRequestInfoProviderProps>,
) {
  const { children, roomRequestId } = props;
  const { examCenter } = useExamCenter();

  const {
    data,
    loading: isLoading,
    // error,
  } = useGetExamRoomRequestInfoByIdQuery({
    variables: {
      getExamRoomRequestInfoByIdInput: {
        id: roomRequestId,
      },
    },
  });

  const examRoomRequestInfo = data?.ecGetExamRoomRequestInfoById?.examRoomRequestInfo;

  const contextValue: ExamRoomRequestInfoContextValue = useMemo(() => {
    return {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      examRoomRequestInfo: examRoomRequestInfo!,
      isReadonly:
        examRoomRequestInfo?.step ===
          ExamLocationRequestWorkflowStepCode.ExamLocationRequestInReview_1 ||
        examRoomRequestInfo?.step ===
          ExamLocationRequestWorkflowStepCode.ExamLocationRequestInReview_2,
    };
  }, [examRoomRequestInfo]);

  if (isLoading) {
    return <Loading sx={{ height: '100%' }} />;
  }

  if (
    examRoomRequestInfo?.step === ExamLocationRequestWorkflowStepCode.ExamLocationRequestApproved
  ) {
    return (
      <Navigate
        to='/:examCenterCode/exam-location/locations'
        params={{
          examCenterCode: examCenter.code,
        }}
      />
    );
  }

  // TODO: handle errors
  // if (error || !examRoomRequestInfo) {
  //   return (
  //     <Navigate
  //       to='/:examCenterCode/exam-location-management/requests'
  //       params={{ examCenterCode }}
  //       replace
  //     />
  //   );
  // }

  return (
    <ExamRoomRequestInfoContext.Provider value={contextValue}>
      {children}
    </ExamRoomRequestInfoContext.Provider>
  );
}

export { ExamRoomRequestInfoContext };
